var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        "min-height": "100vh",
        display: "flex",
        "flex-direction": "column",
        "align-items": "center",
        "padding-top": ".26rem"
      }
    },
    [
      _c("div", { staticClass: "inputBigBox" }, [
        _c("div", { staticClass: "bigTitle" }, [_vm._v("申请人信息")]),
        _vm._v(" "),
        _c("div", { staticClass: "inputBox" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name"
              }
            ],
            attrs: { type: "text", placeholder: "请输入" },
            domProps: { value: _vm.name },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputBox" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "valueBox" }, [
            _c(
              "div",
              {
                staticClass: "flex",
                on: {
                  click: function($event) {
                    _vm.changeGender(0)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "select",
                  class: { active: _vm.gender == 0 }
                }),
                _vm._v("男\n              ")
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex",
                staticStyle: { "margin-left": ".6rem" },
                on: {
                  click: function($event) {
                    _vm.changeGender(1)
                  }
                }
              },
              [
                _c("div", {
                  staticClass: "select",
                  class: { active: _vm.gender == 1 }
                }),
                _vm._v("女\n              ")
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputBox" }, [
          _vm._m(2),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.mobile,
                expression: "mobile"
              }
            ],
            attrs: { type: "text", placeholder: "请输入" },
            domProps: { value: _vm.mobile },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.mobile = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "inputBox" }, [
          _vm._m(3),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.nowLive,
                expression: "nowLive"
              }
            ],
            attrs: { type: "text", placeholder: "请输入" },
            domProps: { value: _vm.nowLive },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.nowLive = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.coopType == 0
          ? _c("div", { staticClass: "inputBox" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.policeStation,
                    expression: "policeStation"
                  }
                ],
                attrs: { type: "text", placeholder: "请输入" },
                domProps: { value: _vm.policeStation },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.policeStation = $event.target.value
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "inputBox" }, [
          _vm._m(5),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.idCard,
                expression: "idCard"
              }
            ],
            attrs: { type: "text", placeholder: "请输入" },
            domProps: { value: _vm.idCard },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.idCard = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.coopType == 1
          ? _c("div", { staticClass: "inputBox" }, [
              _vm._m(6),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.trainingContent,
                    expression: "trainingContent"
                  }
                ],
                attrs: { type: "text", placeholder: "请输入" },
                domProps: { value: _vm.trainingContent },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.trainingContent = $event.target.value
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.coopType == 1
          ? _c("div", { staticClass: "inputBox" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.trainingPosts,
                    expression: "trainingPosts"
                  }
                ],
                attrs: { type: "text", placeholder: "请输入" },
                domProps: { value: _vm.trainingPosts },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.trainingPosts = $event.target.value
                  }
                }
              })
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "inputBox" }, [
          _vm._m(8),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.reason,
                expression: "reason"
              }
            ],
            attrs: { placeholder: "请输入" },
            domProps: { value: _vm.reason },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.reason = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "btnBox" }, [
        _c("div", { staticClass: "btn active", on: { click: _vm.save } }, [
          _vm._v("提交")
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("申请人姓名"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("性别"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("申请人手机号"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("申请人现居地址"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("申请人所属所"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("申请人身份证号码"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("培训内容"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("培训岗位"),
      _c("span", [_vm._v("*")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleBox" }, [
      _vm._v("申请理由"),
      _c("span", [_vm._v("*")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9ace25e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9ace25e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/help.vue
// module id = null
// module chunks = 